import { ChevronDown } from "reicon-react";

import { closeSiblingSelectMenus } from "../lib/select-menu.js";

export type HubSelectItem = {
	value: string;
	label: string;
};

export function HubSelect({
	id,
	label,
	value,
	items,
	onChange,
	className,
	disabled = false,
}: {
	id?: string;
	label: string;
	value: string;
	items: HubSelectItem[];
	onChange: (value: string) => void;
	className?: string;
	disabled?: boolean;
}) {
	const current = items.find((item) => item.value === value)?.label ?? items[0]?.label ?? "";
	const labelId = id ? `${id}-label` : undefined;

	return (
		<div className={className ? `field-select ${className}` : "field-select"}>
			{labelId ? (
				<span id={labelId} className="sr">
					{label}
				</span>
			) : null}
			<details
				className="select hub-field-select"
				onToggle={(event) => closeSiblingSelectMenus(event.currentTarget)}
			>
				<summary aria-label={label} aria-labelledby={labelId} aria-disabled={disabled || undefined}>
					<span>{current}</span>
					<ChevronDown size={12} aria-hidden="true" />
				</summary>
				<div className="select-pop" role="listbox" aria-label={label}>
					{items.map((item) => (
						<button
							key={item.value}
							type="button"
							disabled={disabled}
							role="option"
							aria-selected={item.value === value}
							className={item.value === value ? "select-item active" : "select-item"}
							onClick={(event) => {
								if (disabled) return;
								onChange(item.value);
								event.currentTarget.closest("details")?.removeAttribute("open");
							}}
						>
							{item.label}
						</button>
					))}
				</div>
			</details>
		</div>
	);
}
